// useCategorySwitching.js
import { useEffect } from 'react';
import {getCurrentLayout} from "../../../appLayout";
import {getNavItems} from "../../helpers/sqftHelperUi";
import {checkIfNeedToSetNewCategory, getCurrentQuoteRoomName} from "../../../../misc/categorySwitchingFunctions";
import {ACTIVE_ROOM_TYPE} from "../../../../reducers/sqft/sqftMenuReducer";

const useToggleRoomsSwitcher = (visualizersLoaded,
                                fabricatorSettings,
                                setIsRoomSwitcherVisible,
                                quotes,
                                setSQFTActiveRoomId,
                                setSQFTActiveRoomIndex,
                                setSQFTActiveRoomType,
                                cartItems,
                                activeQuoteIndex,
                                isSquareFootageEnabled) => {

  useEffect(() => {
    if (visualizersLoaded.length && fabricatorSettings.useCategorySwitching) {
      const layout = getCurrentLayout();
      const roomsFeatureGroup = layout.getSubPartFromQtCategories('room');
      const roomsNavItems = getNavItems(roomsFeatureGroup, "", {}, false, true);
      const hasRooms = roomsNavItems.some(roomsNavItem => roomsNavItem.part.partId === 'room');
      const hasMultipleQuotes = quotes.length > 1;
      setIsRoomSwitcherVisible(hasRooms || hasMultipleQuotes);
    }
  }, [isSquareFootageEnabled, visualizersLoaded, fabricatorSettings, setIsRoomSwitcherVisible, quotes]);


  useEffect (() => {
    if (visualizersLoaded.length) {

      //set default settings when loading sqft
      let quoteRoomName = getCurrentQuoteRoomName(cartItems, activeQuoteIndex, true);
      // if (!quoteRoomName) { // removed for now, to be tested
      //   const roomsFeatureGroup = getFeatureGroup('room');
      //   const roomsNavItems = getNavItems(roomsFeatureGroup, "", {}, false, true);
      //
      //   //add room to cart if it not yet added
      //   if (roomsNavItems.length > 0) {
      //     const roomName = roomsNavItems[0].part.getFeatureName()
      //     quoteRoomName = roomName.toLowerCase();
      //     addRoomToCart(roomName);
      //   } else {
      //     quoteRoomName = document.kvConfig.visualizerType
      //   }
      // }
      setSQFTActiveRoomId(quoteRoomName);
      setSQFTActiveRoomIndex(activeQuoteIndex);
      setSQFTActiveRoomType(ACTIVE_ROOM_TYPE.quote);
      checkIfNeedToSetNewCategory(activeQuoteIndex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visualizersLoaded]);
};

export default useToggleRoomsSwitcher;
